import { useQuery } from '@tanstack/react-query'
import { logSentryError } from '@node-space/utils'
import { reactQueryKeys } from 'reactQueryKeys/reactQueryKeys'
import { getTotalBalance } from 'services/WalletsService'

export const useGetTotalBalance = (baseCurrency: string) => {
  return useQuery(reactQueryKeys.totalBalance(baseCurrency), () => getTotalBalance(baseCurrency), {
    refetchOnWindowFocus: false,
    enabled: !!baseCurrency,
    onError: error => {
      logSentryError('Error: get total balance', error, {
        baseCurrency,
      })
    },
  })
}
